export const prints = (state) => { return state.prints };

export const print = (state) => { return state.print };

export const isSaved = (state) => { return state.isPrintSaved };